"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ExpenseRecordGuideWrapper, Object.assign({ className: "surface-white" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80" }, { children: t('비용 기록 어떤 점이 좋아요?') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "record_guide_contents surface-bg" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3", css: { color: 'var(--primary-dark)' } }, { children: t('비용 기록은 Private로 보호 돼요.') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-80" }, { children: t('비용을(=필요 경비) 꼼꼼히 기록할 수록 작가님을 보호해 줄 거예요.') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-80" }, { children: t('순수익이(=소득) 0원일 때 증빙이 쉬워요.') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-80" }, { children: t('해 마다 쉽게 종소세 신고하실 수 있도록 엑셀을 지원해드릴게요.') }))] })), (0, jsx_runtime_1.jsx)("a", Object.assign({ className: "record_guide_link no_anchor_deco subtitle4 gray-80", href: "https://fondee.notion.site/2e7577c985a24028a2f794f2bed35676", target: "_blank", rel: "noopener noreferrer" }, { children: t('종소세 가이드') }))] })));
}
exports.default = default_1;
const ExpenseRecordGuideWrapper = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  max-width: 300px;
  @media (max-width: 768px) {
    max-width: unset;
    padding: 16px 16px 40px;
  }
  .record_guide_contents {
    @media (max-width: 768px) {
      padding: 14px;
      border-radius: 8px;
    }
    padding: 20px 14px;
    border-radius: 16px;
    > div::before {
      content: ' • ';
      margin: -2px 6px 0px;
      font-weight: bold;
    }
    > div {
      display: flex;
      word-break: break-all;
    }
  }
  .record_guide_link {
    align-self: flex-end;
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    border: 1px solid var(--gray-80);
    border-radius: 6px;
  }
`;
